import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalInterceptor } from '@azure/msal-angular';
import { MsalApplicationModule } from './services/msal-application.module';

import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { HeaderComponent } from './components/header/header.component';
import { ProfileComponent } from './components/profile/profile.component';
import { UnauthorisedAccessPageComponent } from './components/unauthorised-access-page/unauthorised-access-page.component';
import { UserRoleChangeComponent } from './components/user-role-change/user-role-change.component';

const BASE_URL = window.location.origin;
@NgModule({
  declarations: [
    PageNotFoundComponent,
    HeaderComponent,
    ProfileComponent,
    UnauthorisedAccessPageComponent,
    UserRoleChangeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    SharedModule,
    MsalApplicationModule,
    DragDropModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
  ],
  exports: [
    SharedModule,
    HeaderComponent,
    ProfileComponent,
    UserRoleChangeComponent,
  ],
})
export class CoreModule {}
